import React from 'react';
import Avatar from '@mui/material/Avatar';


function ColoredUserAvatar({ name, color, sx }) {

    function stringToColor(string) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }

    function initials(string) {
        const words = string.split(' ').filter(w => w.length > 0);
        if (words.length >= 2) {
            return `${words[0][0]}${words[1][0]}`.toUpperCase();
        }
        return string.slice(0, 2).toUpperCase();
    }


    return (
        <Avatar sx={{
            bgcolor: color || stringToColor(name),
            ...sx,
        }}
        >
            {initials(name)}
        </Avatar>
    );
}

export default ColoredUserAvatar;
